module.exports = __webpack_public_path__ + "static/media/Regulamento_TASTEPORTUGAL.dbb80e4d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/Regulamento_TASTEPORTUGAL.pdf
// module id = 823
// module chunks = 0